export class QuotesManager {
    #quotePollingEntries = new Map();
    #pollInterval = null;
    #pollIntervalMs = 30_000;
    #getBestQuote;
    constructor(params) {
        this.#pollIntervalMs = params.bestQuotePollIntervalMs || this.#pollIntervalMs;
        this.#getBestQuote = params.getBestQuote;
    }
    pollBestQuote = async ({ quoteParams, onError, abortSignal, }) => {
        if (abortSignal.aborted)
            return;
        const key = quoteParams.quoteId;
        const handler = { onError, abortSignal };
        if (this.#quotePollingEntries.has(key)) {
            const entry = this.#quotePollingEntries.get(key);
            entry.refs++;
            entry.handlers.add(handler);
        }
        else {
            this.#quotePollingEntries.set(key, {
                refs: 1,
                params: quoteParams,
                handlers: new Set([handler]),
            });
        }
        const onAbort = () => {
            const entry = this.#quotePollingEntries.get(key);
            if (entry) {
                entry.refs--;
                entry.handlers.delete(handler);
                if (entry.refs === 0) {
                    this.#quotePollingEntries.delete(key);
                }
            }
            if (this.#quotePollingEntries.size === 0) {
                this.#stopPolling();
            }
        };
        abortSignal.addEventListener('abort', onAbort, { once: true });
        void this.#getBestQuote(quoteParams).catch((err) => {
            if (err instanceof Error) {
                onError?.(err);
            }
        });
        if (!this.#pollInterval) {
            this.#startPolling();
        }
    };
    #startPolling() {
        const poll = async () => {
            const entries = [...this.#quotePollingEntries.values()];
            entries.forEach(async (entry) => {
                try {
                    await this.#getBestQuote(entry.params);
                }
                catch (err) {
                    if (err instanceof Error) {
                        entry.handlers.forEach(({ onError, abortSignal }) => {
                            if (!abortSignal.aborted) {
                                onError?.(err);
                            }
                        });
                    }
                }
            });
        };
        this.#pollInterval = setInterval(poll, this.#pollIntervalMs);
    }
    #stopPolling() {
        if (this.#pollInterval) {
            clearInterval(this.#pollInterval);
            this.#pollInterval = null;
        }
    }
}
